import { AllRfqThemeSizeConfig } from './types';

const medium: AllRfqThemeSizeConfig = {
  allRfq: {},
};

export default medium;
